import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './aprovar-rede-social.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  faFacebookSquare, faInstagram, faLinkedin, faYoutube,
  faTiktok, faXTwitter, faWhatsapp, faTelegram, faTumblrSquare
} from '@fortawesome/free-brands-svg-icons';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Radio,
  RadioGroup,
  FormHelperText,
  Spinner,
  Tooltip,
  IconButton,
} from '@chakra-ui/react';
import * as api from '../../../../api/redesSociais';
import * as apiPendencia from '../../../../api/pendencia';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { listarExecutores } from '../../../../api/noticia';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImageDropzoneDisabled } from '../../../../components/common/imageDropzoneDisabled/imageDropzoneDisabled';
import { MdInfoOutline } from 'react-icons/md';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const AprovarPublicacaoRedeSocial: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];
  const { id } = useParams();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    imagem: { value: string; error: boolean };
    links: { value: string; error: boolean };
    localizacao: { value: string; error: boolean };
    mensagem: { value: string; error: boolean };
    categoriaId: { value: string; error: boolean };
    redeId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    imagem: { value: '', error: false },
    links: { value: '', error: false },
    localizacao: { value: '', error: false },
    mensagem: { value: '', error: false },
    categoriaId: { value: '', error: false },
    redeId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageVideoBase64, setImageVideoBase64] = useState<string>('');
  const [categorias, setCategorias] = useState<any[]>([]);
  const [redes, setRedes] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [executor, setExecutor] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [listagemIcones, setListagemIcones] = useState<[]>([]);
  const [idUrl, setIdUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isReprovandoButton, setReprovandoButton] = useState<boolean>(false);
  const [isAprovandoButton, setAprovandoButton] = useState<boolean>(false);

  const obterPublicacao = async () => {
    setIsLoading(true);
    try {
      const publicacaoData = await api.obterPublicacaoRedeSocial(Number(id));
      const {
        nomePublicacao,
        datPublicacao,
        dscPublicacao,
        dscEnderecoEvento,
        seqCategoria,
        contasRedeSocial,
        binPublicacao,
        urlBin,
        dscTags,
        dscCitacaoUsuario,
        pendencia
      } = publicacaoData;

      setExecutor(publicacaoData.pendencia.seqExecutor)

      const codRede = contasRedeSocial[0].codRede;
      setIdUrl(codRede);

      let exigeAprovacaoValue = 0;

      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
        setSelectedUser(pendencia.seqExecutor);
      }
      const usuarioIdValue = pendencia?.seqExecutor;

      setFormValues((prevValues: any) => ({
        ...prevValues,
        titulo: { value: nomePublicacao, error: false },
        mensagem: { value: dscPublicacao, error: false },
        localizacao: { value: dscEnderecoEvento, error: false },
        data: { value: datPublicacao || today, error: false },
        links: { value: urlBin || '', error: false },
        imagem: { value: binPublicacao || '', error: false },
        categoriaId: { value: seqCategoria.toString(), error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        usuarioId: { value: usuarioIdValue, error: false },
        redeId: { value: contasRedeSocial.map((item: any) => item.seqConfigRede.toString()), error: false },
      }));

    } catch (error) {
      console.error("Erro ao buscar dados da publicação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const obterContasRedeSocial = async () => {
    setLoading(true);
    try {
      const data = await api.listarContasRedesSociais(paginaAtual, tamanhoPagina, Number(idUrl));

      if (data.conteudo && data.conteudo.length > 0) {
        setRedes(data.conteudo.map((usuario: any) => ({
          seqConfigRede: usuario.seqConfigRede,
          codRede: usuario.codRede,
          dscUsuario: usuario.dscUsuario,
        })));
      } else {
        setRedes([]);
      }

      setTotalPages(data.totalredes);
    } catch (error) {
      console.error('Erro ao buscar contas em redes sociais:', error);
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        setNomeUsuarioLogado(usuario.dscNome);

      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const listarCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    obterPublicacao();
    listarCategorias();
    fetchAprovadoresAtivos();
  }, []);

  useEffect(() => {
    if (idUrl !== null && idUrl !== undefined) {
      obterContasRedeSocial();
    }
  }, [idUrl]);

  useEffect(() => {
    const listarIconesRedesSociais = async () => {
      setLoading(true);
      try {
        const data = await api.listarRedesSociais(paginaAtual, tamanhoPagina);
        setListagemIcones(data.formatoArquivos);
      } catch (error) {
        console.error('Erro ao buscar ícones de redes sociais:', error);
      } finally {
        setLoading(false);
      }
    };

    listarIconesRedesSociais();
  }, []);

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const tituloRede = (codigo: number) => {
    const titles: { [key: number]: string } = {
      0: 'Facebook',
      1: 'Instagram',
      2: 'LinkedIn',
      3: 'Youtube',
      4: 'TikTok',
      5: 'X (Antigo Twitter)',
      6: 'Whatsapp',
      7: 'Telegram',
      8: 'Tumblr',
      9: 'Página Internet',
    };

    return titles[codigo] || '';
  };

  const iconeRedeSocial = (id: number) => {
    const icones: { [key: number]: { icon: any, color: string } } = {
      0: { icon: faFacebookSquare, color: "#1789fc" },
      1: { icon: faInstagram, color: "#ec1393" },
      2: { icon: faLinkedin, color: "#1DA1F2" },
      3: { icon: faYoutube, color: "#ff0000" },
      4: { icon: faTiktok, color: "#080404" },
      5: { icon: faXTwitter, color: "#080404" },
      6: { icon: faWhatsapp, color: "#43e460" },
      7: { icon: faTelegram, color: "#088ccc" },
      8: { icon: faTumblrSquare, color: "#384c5c" },
    };

    return icones[id] || { icon: faGlobe, color: "#3b87d8" };
  };

  function getMaxLength(id: number) {
    switch (Number(idUrl)) {
      case 0: return 63206;
      case 1: return 2200;
      case 2: return 3000;
      case 3: return 5000;
      case 4: return 2200;
      case 5: return 280;
      case 6: return 65536;
      case 7: return 4096;
      case 8: return 4096;
      default: return 200;
    }
  }

  function isImagemVideoObrigatorio(id: number) {
    switch (id) {
      case 4:
      case 3:
      case 1:
        return true;
      default:
        return false;
    }
  }

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setAprovandoButton(true);

    const params = Number(id);

    try {
      await apiPendencia.aprovarConteudo(params);
      setAprovandoButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Publicação aprovada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    } catch (error) {
      setAprovandoButton(false);
      console.error('Erro ao aprovar publicação:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao aprovar publicação. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    }
  };

  const handleReprovarPublicacao = async () => {

    const { usuarioId } = formValues;

    const motivoReprovacao = await Swal.fire({
      input: 'textarea',
      width: '50%',
      title: 'Qual é o motivo da reprovação?',
      inputPlaceholder: 'Digite o motivo da reprovação aqui',
      inputAttributes: {
        'aria-label': 'Digite o motivo da reprovação aqui'
      },
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar Motivo',
      confirmButtonColor: '#1665D8',
      cancelButtonColor: '#EDF2F7',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.disabled = true;
          const input = Swal.getInput();
          if (input) {
            input.addEventListener('input', () => {
              confirmButton.disabled = input.value.trim().length < 1;
            });
          }
        }
      },
    });

    if (motivoReprovacao.isConfirmed) {
      setReprovandoButton(true);
      const params = {
        pendencia: {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
          dscObs: motivoReprovacao.value,
        }
      };

      try {
        await apiPendencia.reprovarConteudo(Number(id), params);
        setReprovandoButton(false);
        await Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'A publicação foi reprovada com sucesso.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      } catch (error) {
        setReprovandoButton(false);
        console.error('Erro ao reprovar publicação:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Ocorreu um erro ao reprovar a publicação. Tente novamente.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      }
    }
  }

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height={formValues.exigeAprovacao.value === 1 ? '100%' : '100%'}
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading display={'flex'} alignItems={'center'} mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Aprovar publicação
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <>

          <Heading display={'flex'} alignItems={'center'} mt="20px" fontWeight="500" fontSize="20px" color="#3b3b3b" w="100%">
            <FontAwesomeIcon
              style={{ marginRight: '10px', fontSize: '25px' }}
              icon={iconeRedeSocial(Number(idUrl)).icon}
              color={iconeRedeSocial(Number(idUrl)).color}
            />
            {`${tituloRede(Number(idUrl))}`}
          </Heading>
          <Box m="40px 0" w="100%">
            <form onSubmit={handleFormSubmit}>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <FormControl isRequired isInvalid={formValues.categoriaId.error}>
                    <FormLabel mb="8px">Categoria da Publicação</FormLabel>
                    <Select
                      disabled={true}
                      placeholder='Selecione uma Categoria'
                      borderColor="gray.300"
                      _hover={{ borderColor: 'blue.500' }}
                      value={formValues.categoriaId.value}
                      className='opacidade'
                    >
                      {categorias.length > 0 ? (
                        categorias.map(categoria => (
                          <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                            {categoria.dscCategoria}
                          </option>
                        ))
                      ) : (
                        ''
                      )}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-6 mb-4">
                  <FormControl isRequired isInvalid={formValues.titulo.error}>
                    <FormLabel mb="8px">Título da Publicação</FormLabel>
                    <CustomInput
                      isDisabled={true}
                      className='opacidade'
                      value={formValues.titulo.value}
                      placeholder="Digite um título"
                      maxLength={100}
                    />
                  </FormControl>
                </div>

                <div className="col-md-6 mb-4">
                  <FormControl isInvalid={formValues.mensagem.error}>
                    <FormLabel mb="8px">
                      Mensagem/Descrição
                      <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                      <Tooltip
                        label="Insira hashtags (ex.: #exemplo) e links (ex.: https://www.exemplo.com), que serão automaticamente formatados para a publicação."
                        aria-label="Informação sobre a mensagem/Descrição"
                      >
                        <IconButton
                          className="icones"
                          icon={<MdInfoOutline />}
                          variant="link"
                          aria-label="Informação"
                          size="md"
                          color="#2883de"
                        />
                      </Tooltip>
                    </FormLabel>
                    <CustomTextArea
                      isDisabled={true}
                      className='opacidade'
                      style={{ resize: 'none' }}
                      value={formValues.mensagem.value}
                      placeholder="Digite uma mensagem ou descrição"
                      height={'145px'}
                      maxLength={getMaxLength(Number(idUrl))}
                    />
                    <FormHelperText>
                      Máximo de caracteres: {getMaxLength(Number(idUrl))}
                    </FormHelperText>
                  </FormControl>
                </div>

                <div className="col-md-6 mb-4">
                  <FormControl isRequired={isImagemVideoObrigatorio(Number(idUrl))}>
                    <FormLabel mb="8px">Mídia</FormLabel>
                    {imageVideoBase64 && imageVideoBase64.startsWith("data:video/") ? (
                      <video controls className='tamanho-video'>
                        <source src={imageVideoBase64} type="video/mp4" />
                        Seu navegador não suporta o formato de vídeo.
                      </video>
                    ) : (
                      <ImageDropzoneDisabled
                        base64={formValues.imagem.value || ''}
                        width={300}
                      />
                    )}

                  </FormControl>
                </div>

                
                <div className="col-md-3 mb-4">
                  <Flex direction="row" justify="space-between" align="flex-start">
                    <FormControl>
                      <Flex justify="space-between" align="center" mb="8px">
                        <FormLabel mb="8px">
                          Escolha em quais contas deseja publicar
                          <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                        </FormLabel>
                      </Flex>

                      <div className="sidebar-checkbox-pagina">
                        <Stack spacing={5}>
                          {redes.length > 0 ? (
                            redes.map((rede) => {
                              const inputRef = React.createRef<HTMLInputElement>();
                              return (
                                <Flex key={rede.seqConfigRede} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                                  <Checkbox
                                    disabled={true}
                                    className="opacidade checkredes"
                                    isChecked={formValues.redeId.value.includes(rede.seqConfigRede.toString())}
                                  >
                                    {rede.dscUsuario}
                                  </Checkbox>
                                </Flex>
                              );
                            })
                          ) : (
                            <p>Não há contas cadastradas.</p>
                          )}
                        </Stack>
                      </div>
                    </FormControl>
                  </Flex>
                </div>
                <div className="col-md-3 mb-4">
                  <FormControl isRequired>
                    <FormLabel mb="8px">Data para Publicação</FormLabel>
                    <CustomInput
                      isDisabled={true}
                      className='opacidade'
                      id="social-media-approve-publication-date"
                      type="date"
                      value={formValues.data.value}
                      min={today}
                    />
                  </FormControl>
                </div>

                <div className="col-md-6 mb-4">
                  <div className="row">
                    <div className={`mb-4 col-md-${formValues.exigeAprovacao.value === 1 ? '4' : '6'}`}>
                      <FormControl isRequired>
                        <FormLabel mb="8px">Exige aprovação</FormLabel>
                        <RadioGroup
                          isDisabled={true}
                          className='opacidade'
                          mt={3.5}
                          value={formValues.exigeAprovacao.value.toString()}
                        >
                          <Radio value="1" mr={5}>Sim</Radio>
                          <Radio value="0">Não</Radio>
                        </RadioGroup>
                      </FormControl>
                    </div>

                    {formValues.exigeAprovacao.value === 1 && (
                      <div className="col-md-8 mb-4">
                        <FormControl isRequired>
                          <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                          <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                            <Stack spacing={5}>
                              {aprovadores.length > 0 ? (
                                aprovadores.map((aprovador: any) => (
                                  <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                    <Radio
                                      isDisabled={true}
                                      className="opacidade radioAprovadoresNoticia"
                                      value={aprovador.seqUsuario.toString()}
                                      isChecked={selectedUser === aprovador.seqUsuario}
                                    >
                                      {aprovador.dscNome}
                                    </Radio>
                                  </Flex>
                                ))
                              ) : (
                                <p>Não há lista de aprovadores disponíveis.</p>
                              )}
                            </Stack>
                          </div>
                        </FormControl>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <Flex justifyContent="end">
                <Button
                  m="6px"
                  onClick={handleReprovarPublicacao}
                  isDisabled={executor != seqUsuario}
                  isLoading={isReprovandoButton}
                  loadingText="Reprovando Publicação..."
                >
                  Reprovar Publicação
                </Button>
                <Button
                  type="submit"
                  m="6px"
                  color="#FFF"
                  bgColor="#1665D8"
                  _hover={{ opacity: 0.8 }}
                  isDisabled={executor != seqUsuario}
                  isLoading={isAprovandoButton}
                  loadingText="Aprovando Publicação..."
                >
                  Aprovar Publicação
                </Button>
              </Flex>
              <Flex hidden={executor == seqUsuario} justifyContent="end">
                <p className='mansagem-erro-executor'>
                  Você não é o aprovador desta publicação.
                </p>
              </Flex>
            </form>
          </Box>
        </>
      )}

    </Flex>
  );
};

export default AprovarPublicacaoRedeSocial;
